export const STATS = `
query stats(
  $tenant_id: Int!,
  $filter: FilterStatsInput
  $supplier_id: Int
){
  stats(
    tenant_id:$tenant_id,
    filter:$filter
    supplier_id: $supplier_id
  ){
    __typename
    ...on Stats{
      order_stats{
        order_status{
          translation_key
          hex_color
        }
        count
      }
      product_stats{
        ranking{
          product_specification{
            code
            option_1{
              value
            }
            option_2{
              value
            }
            option_3{
              value 
            }
            product_picture{
              url
              filename
            }
            product{
              id
              name
              has_variants            
            }
          }          
          amount_sold
        }
      }
      money_stats{
        delivered_order_total
        delivered_shipping_total
        delivered_product_cost_total
        delivered_commission_total
        total_earnings
        returned_shipping_total
        delivered_cod_commission_total
        delivered_supplier_commission_total
        delivered_fulfillment_commission_total
      }
      delivery_rate
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;
